module.exports = new __parcel__URL__("custom-reports.800596fa.svg").toString();